import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authSlice from "./services/authSlice";
import classesSlice from "./services/classesSlice";
import dashboardSlice from "./services/dashboardSlice";
import contestTypeSlice from "./services/contestTypeSlice";
import contestSlice from "./services/contestSlice";
import subjectSlice from "./services/subjectSlice";
import subTopicSlice from "./services/subTopicSlice";
import studentSlice from "./services/studentSlice";
import bannerSlice from "./services/bannerSlice";
import informationSlice from "./services/informationSlice";
import reportSlice from "./services/reportSlice";
import kycSlice from "./services/kycSlice";
import fileSlice from "./services/fileUploadSlice";
import contestEarningSlice from "./services/contestEarningSlice";
import questionSlice from "./services/questionSlice";
import courseSlice from "./services/courseSlice";
import balanceSlice from "./services/balanceSlice";
import examTypeSlice from "./services/examTypeSlice";
import goalSlice from "./services/goalSlice";
import contactSlice from "./services/contactSlice";
import blogSlice from "./services/blogSlice";
import trustedInstituteSlice from "./services/trustedInstituteSlice";
import faqSlice from "./services/faqSlice";
import howItWorkSlice from "./services/howItWorkSlice";
import featureSlice from "./services/featureSlice";
import interfaceSlice from "./services/interfaceSlice";
import moduleSlice from "./services/moduleSlice";
import lectureSlice from "./services/lectureSlice";
import coursePurchaseSlice from "./services/coursePurchaseSlice";
import workshopSlice from "./services/workshopSlice";
import workshopRegisterSlice from "./services/workshopRegisterSlice";
import workshopTestimonialSlice from "./services/workshopTestimonialSlice";
import couponSlice from "./services/couponSlice";
import youtubeVisualsSlice from "./services/youtubeVisualsSlice";
import socialMediaVisualsSlice from "./services/socialMediaVisualsSlice";
import userAdminSlice from "./services/userAdminSlice"
import withdrawRequestSlice from "./services/withdrawalRequestSlice"
import freeMockTestSlice from "./services/freeMockTestSlice"


const combineReducer = combineReducers({
  auth: authSlice,
  dashboard: dashboardSlice,
  classes: classesSlice,
  contestType: contestTypeSlice,
  contest: contestSlice,
  subject: subjectSlice,
  subTopic: subTopicSlice,
  student: studentSlice,
  banner: bannerSlice,
  information: informationSlice,
  report: reportSlice,
  kyc: kycSlice,
  file: fileSlice,
  contestEarning: contestEarningSlice,
  question: questionSlice,
  course: courseSlice,
  balance: balanceSlice,
  examType: examTypeSlice,
  goal: goalSlice,
  contact: contactSlice,
  blog: blogSlice,
  trustedInstitute: trustedInstituteSlice,
  faq: faqSlice,
  howItWork: howItWorkSlice,
  feature: featureSlice,
  interface: interfaceSlice,
  module: moduleSlice,
  lecture: lectureSlice,
  coursePurchase: coursePurchaseSlice,
  workshop: workshopSlice,
  workshopRegister: workshopRegisterSlice,
  workshopTestimonial: workshopTestimonialSlice,
  coupon: couponSlice,
  youtubeVisuals: youtubeVisualsSlice,
  socialMediaVisuals: socialMediaVisualsSlice,
  userAdmin: userAdminSlice,
  withdrawRequest: withdrawRequestSlice,
  freeMockTest: freeMockTestSlice,
});

const store = configureStore({
  reducer: combineReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
});

export default store;
